import React from 'react';


const onCategoryClick = (category, onClick) => (e) => {
  e.preventDefault();
  onClick(category);
};

const CategoryEntry = ({ activeCategory, category, onClick }) => {
  const {
    color,
    id,
    name,
  } = category;
  const isActive = activeCategory.id === id;

  const spanStyles = {
    borderBottomColor: color,
  };

  const entryStyles = {};
  if (isActive) {
    entryStyles.backgroundColor = color;
  }

  return (
    <a href="#z"
      className={isActive ? 'nav-entry nav-active' : 'nav-entry'}
      onClick={onCategoryClick(category, onClick)}
      style={entryStyles}
    >
      <span style={spanStyles}>{name}</span>
    </a>
  );
};

export default CategoryEntry;



// WEBPACK FOOTER //
// ./book/src/commons/components/book/CategoryEntry.jsx